import { FC } from 'react';

import { TypePlayGeniusOrder } from '@/lib/api/orderManager/types/TypePlayGeniusOrder';
import { TypeExternalPaymentMethod } from '@/lib/api/productCatalog/types';
import { TypeSubEngineInstallment } from '@/lib/api/subscriptionManager/types';

import { TypeAccountERCPageTranslations } from '@/utils/translations/types/TypeAccountERCPageTranslations';

import { OrderDetails } from './components/OrderDetails';
import { OrderInsights } from './components/OrderInsights';
import { ProductInfo } from './components/ProductInfo';
import { TypeProduct } from '@/core/generated-types/TypeProduct';

type BoxProps = {
  t: TypeAccountERCPageTranslations;
  orderData?: TypePlayGeniusOrder;
  installmentData?: TypeSubEngineInstallment;
  productData?: TypeProduct;
  paymentMethodData?: TypeExternalPaymentMethod;
  isCurrentBox?: boolean;
  isNextOrder?: boolean;
  isUpcomingBox?: boolean;
};

const Box: FC<BoxProps> = ({
  t,
  orderData,
  installmentData,
  productData,
  paymentMethodData,
  isCurrentBox = false,
  isNextOrder = false,
  isUpcomingBox = false,
}) => (
  <div data-testid="box">
    {(isCurrentBox || isNextOrder) && orderData && (
      <OrderInsights
        t={t}
        orderData={orderData}
        installmentData={installmentData}
        paymentMethodData={paymentMethodData}
        isNextOrder={isNextOrder}
      />
    )}

    <div className="p-6 md:p-8 shadow-[0px_4px_8px_0px_rgba(0,0,0,0.16)]">
      {productData && (
        <ProductInfo
          t={t}
          product={productData}
          shipDate={installmentData?.scheduled_date}
          isCurrentBox={isCurrentBox}
          isNextOrder={isNextOrder}
          isUpcomingBox={isUpcomingBox}
        />
      )}

      {isNextOrder && orderData && <OrderDetails t={t} orderData={orderData} />}
    </div>
  </div>
);

export default Box;
